//@ts-ignore
import React, { useState, useEffect } from 'react'
import { Link } from '@material-ui/core';
import { MyPATTextField } from '../../../common';

const ordinalNumbers = {
    0: 'First',
    1: 'Second',
    2: 'Third',
    3: 'Fourth',
    4: 'Fifth',
    5: 'Sixth',
    6: 'Seventh',
    7: 'Eighth',
    8: 'Ninth',
    9: 'Tenth',
}

interface FillInTheBlanksAnswer {
    id: string,
    value: string
}

const FillInTheBlanks = (props: any) => {
    const noOfBlanksAdmissable = Object.keys(ordinalNumbers).length;
    const [answers, setAnswer] = useState<FillInTheBlanksAnswer[]>([{
        id: new Date().getTime() + '',
        value: ''
    }]);
    let showAddMoreButton = true;
    let { parentClass } = props;
    let { availableAnswers } = props;
    useEffect(() => {
        if(!availableAnswers.length) return;
        const updatedAnswersState = availableAnswers.map((answer:any) => ({value: answer.value, id: new Date().getTime() + ''}));
        setAnswer(updatedAnswersState);
    }, [availableAnswers]);
    return (
        <>
            {
                answers.map((answer:FillInTheBlanksAnswer, index:number) => {
                    showAddMoreButton = (index < (noOfBlanksAdmissable-1));
                    return (
                        <div key={index} className={parentClass}>
                            <MyPATTextField fullWidthControl fullWidthInput 
                            value={answer.value}
                            onChange={(e:any) => {
                                const value = e.target.value;
                                setAnswer((allAnswers: FillInTheBlanksAnswer[]) => {
                                    const updatedAnswers = allAnswers.map((answr, i) => index === i ? {...answr, value} : answr);
                                    props.onAnswerUpdate(updatedAnswers);
                                    return updatedAnswers;
                                });
                            }}
                            //@ts-ignore
                            placeholder={`Enter # Separated Answers for ${ordinalNumbers[index]} Blank`}  
                            />
                            {(<div className={"deleteActionButton visible-"+!!index} onClick={() => {
                                setAnswer((currentAnswers:FillInTheBlanksAnswer[]) => {
                                    const updatedAnswers = currentAnswers.filter((x, i) => index !== i);
                                    props.onAnswerUpdate(updatedAnswers);
                                    return updatedAnswers;
                                });
                            }}><img src="/assets/svg/delete.svg" alt="Delete"/></div>)}
                        </div>
                    )
                })
            }
            {showAddMoreButton && (<div>
                <Link component="button" variant="body2" onClick={() => {
                    setAnswer((allAnswers:FillInTheBlanksAnswer[]) => {
                        const updatedAnswers = [...allAnswers, {id: new Date().getTime() + '', value: ''}];
                        props.onAnswerUpdate(updatedAnswers);
                        return updatedAnswers;
                    });
                }} style={{fontWeight: 600}}>+ Add Answer</Link>
            </div>)}
        </>
    );
}

export default FillInTheBlanks;